import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';

import { Heading } from '../../../components';

import { getIncludedFieldItems } from '../listingFieldHelpers';

import css from './SectionWhatsIncluded.module.css';

/**
 * Displays custom listing fields as a grid of info boxes.
 *
 * @component
 */
const SectionWhatsIncluded = props => {
  const { className, rootClassName, ...fieldProps } = props;
  const items = getIncludedFieldItems(fieldProps);

  if (!items.length) {
    return null;
  }

  const classes = classNames(rootClassName || css.root, className);

  return (
    <section className={classes}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.whatsIncludedTitle" />
      </Heading>
      <ul className={css.grid}>
        {items.map(({ key, label, value }) => (
          <li key={key} className={css.box}>
            <span className={css.boxLabel}>{label}</span>
            <span className={css.boxValue}>{value}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default SectionWhatsIncluded;
